import RequireAuth from "@/components/hoc/RequireAuth";
import RootLayout from "@/components/layout/RootLayout";
import useInjectSidebar from "@/hooks/useInjectSidebar";
import KpiFinder from "@/pages/kpi/KpiFinder";
import KpiFinderLayout from "@/pages/kpi/KpiFinderLayout";
import ProjectFinder from "@/pages/project/ProjectFinder";
import ProjectFinderLayout from "@/pages/project/ProjectFinderLayout";
import StrategicPlanningFinder from "@/pages/strategic-planning/StrategicPlanningFinder";
import StrategicPlanningFinderLayout from "@/pages/strategic-planning/StrategicPlanningFinderLayout";

const Layout = () => useInjectSidebar({ sidebarName: "workspace" })(RootLayout);

export const workspaceRoute = {
    path: "/workspace",
    element: (
        <RequireAuth>
            <Layout />
        </RequireAuth>
    ),
    children: [
        {
            index: true,
            element: <div>Welcome to personal's workspace.</div>,
        },
        {
            path: "strategic-plannings",
            element: <StrategicPlanningFinderLayout />,
            children: [
                {
                    index: true,
                    element: <StrategicPlanningFinder />,
                },
            ],
        },
        {
            path: "projects",
            element: <ProjectFinderLayout />,
            children: [
                {
                    index: true,
                    element: <ProjectFinder />,
                },
            ],
        },
        {
            path: "kpis",
            element: <KpiFinderLayout />,
            children: [
                {
                    index: true,
                    element: <KpiFinder />,
                },
            ],
        },
    ],
};
